'use strict';
const angular = require('angular');
const Mustache = require('mustache/mustache.min');

export class SendAttachmentEmailComponent {
  /*@ngInject*/
  constructor($uibModal, SettingsService) {
    this.$uibModal = $uibModal;

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["undo","redo"]/*,
      ["backgroundColor","fontColor","fontName", "fontSize"]*/
    ];

    SettingsService.getByName({name: 'client'}, clientConfig => {
      this.clientVars = {
        MGNT_COMPANY_NAME: clientConfig.data.name,
        MGNT_COMPANY_ADDRESS: clientConfig.data.address,
        MGNT_COMPANY_PHONE: clientConfig.data.phone || '-',
        MGNT_COMPANY_FAX: clientConfig.data.fax || '-'
      };
    })
  }

  $onInit() {
    this.config = this.resolve.config;

    this.contextVars = this.config.contextVars;

    this.attachments = this.config.attachments || [];
    this.emails = this.config.emails || [];
    let _sequences = this.config.templates || [];

    this.templates = _sequences.map(sequence => {
      return {
       subject: sequence.mailSubjectTemplate,
       body: sequence.mailBodyTemplate,
       level: sequence.level
      }
    });

    this.email = {
      /*subject: this.config.subject,
      body: this.config.body,
      email: this.config.email,*/
      attachment: this.config.attachments.find(att => att._id == this.config.attachment)
    }
  };

  openPreviewModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'iframePreview',
      resolve: {
        config: function() {
          return {
            content: that.generateMailBody(that.email)
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );
  }

  updateTemplate() {
    let template = this.templates.find(t => t.level == this.selectedTemplateLevel);

    if (template) {
      this.email.subject = template.subject;
      this.email.body = template.body;
    }

  }

  ok() {
    this.email.body = this.generateMailBody(this.email);
    this.close({$value: this.email});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  generateMailBody(mail) {
    if (!mail || !mail.body)
      return "";
    
    const TMPL_TAG_SUBJECT = "{tmpl:subject}";
    const TMPL_TAG_CONTENT = "{tmpl:content}";
    const TMPL_TAG_HEADER = "{tmpl:header}";
    const TMPL_TAG_DATE = "{tmpl:date}";
    const TMPL_TAG_MAIL_URL = "{tmpl:mailurl}";

    const TMPL_TAG_OPEN_SECTION = "{tmpl:section-start}";
    const TMPL_TAG_CLOSE_SECTION = "{tmpl:section-end}";

    const TMPL_HTML_FRAME2 = require('./email-template.html');

    let content = mail.body.split(/\n/).join("<br/>");
/*
    let header = `<img src="https://carver.conduu.com/api/storage/public/5d85f4f842a17d0099e6b157" style="float:right" />
<div style="text-align: left"><h5>{{MGNT_COMPANY_NAME}}<br/>
{{MGNT_COMPANY_ADDRESS}}<br/>
Phone: {{MGNT_COMPANY_PHONE}} | Fax: {{MGNT_COMPANY_FAX}}</h5></div>`;*/

    let pageTemplate = TMPL_HTML_FRAME2.replace(TMPL_TAG_CONTENT, content);
    //pageTemplate = pageTemplate.replace(TMPL_TAG_HEADER, header);
      //TMPL_HTML_FRAME2.replace(TMPL_TAG_CONTENT, "");
    pageTemplate = pageTemplate.replace(TMPL_TAG_SUBJECT, mail.subject);
    //pageTemplate = pageTemplate.replace(TMPL_TAG_DATE, new Date().toLocaleString());
    //pageTemplate = pageTemplate.replace(TMPL_TAG_MAIL_URL, this.baseUrl + '/api/mails/html/' + (this.mailId || 'unavailable'));
    
    let sectionTemplate = pageTemplate.substring(
      pageTemplate.lastIndexOf(TMPL_TAG_OPEN_SECTION) + TMPL_TAG_OPEN_SECTION.length,
      pageTemplate.lastIndexOf(TMPL_TAG_CLOSE_SECTION));

    let __VARS = Object.assign({}, this.contextVars, this.clientVars);

    return Mustache.render(pageTemplate, __VARS);
  }
}

export default angular.module('conduu.sendAttachmentEmail', [])
  .component('sendAttachmentEmail', {
    template: require('./send-attachment-email.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: SendAttachmentEmailComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/send-attachment-email/send-attachment-email.component.js